import React from 'react'

import LiveMapContainer from 'Components/LiveMap'
import CityPage from 'Containers/City/Page'
import StyledIconButton from '../../../../Components/Form/StyledIconButton'
import EditIcon from '@material-ui/icons/Edit'
import { Link } from 'react-router-dom'
import { getCityLink } from 'Utils/Link'
import { ACTION_EDIT } from 'constants.js'

const LiveMap = ({ cityId, cityName, nav, history, match, clients }) => {
  return (
    <CityPage
      active={nav}
      cityId={cityId}
      history={history}
      match={match}
      cityName={cityName}
      breadcrumbs={[{ label: 'Live Map' }]}
    >
      <Link to={getCityLink(cityId, ACTION_EDIT)} className="link-edit-main">
        <StyledIconButton>
          <EditIcon />
        </StyledIconButton>
      </Link>

      <LiveMapContainer cityId={cityId} clients={clients} />
    </CityPage>
  )
}

export default LiveMap
